import { render, staticRenderFns } from "./Caps.vue?vue&type=template&id=d063bd54&"
import script from "./Caps.vue?vue&type=script&lang=js&"
export * from "./Caps.vue?vue&type=script&lang=js&"
import style0 from "./Caps.vue?vue&type=style&index=0&id=d063bd54&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports